import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
export default class SummaryPageTabsStyle {
    static getStyle(options) {
        const { spacing, color } = options.theme;
        const hiddenSkapaTabsStyle = options.hideSkapaTabsOnPrint
            ? css `
					skapa-tabs {
						display: none;
					}
				`
            : null;
        return css `
			${Text.CSS}

			.contentToPrint {
				position: fixed;
				visibility: hidden;
			}

			skapa-inline-message {
				margin-bottom: ${spacing.space100 / 16}rem;
				color: ${color.text.default};
			}

			slot[name='panels'] {
				scroll-margin-top: ${spacing.space250 / 16}rem;
			}

			skapa-tabs > [role='tabpanel'] {
				scroll-margin-top: ${(spacing.space300 * 2) / 16}rem;
			}

			.imageGrid {
				display: grid;
				grid-template-columns: 1fr 1fr;
				row-gap: ${spacing.space200 / 16}rem;
				column-gap: ${spacing.space300 / 16}rem;
			}

			.avoidBreak {
				break-inside: avoid;
			}

			@media print {
				${hiddenSkapaTabsStyle ?? ''}

				.contentToPrint {
					position: relative;
					visibility: visible;
				}

				.subheader {
					font-weight: bold;
					color: ${color.text.dark};
					margin: 0;
					margin-bottom: ${spacing.space50 / 16}rem;
				}
			}
		`;
    }
}
//# sourceMappingURL=SummaryPageTabsStyle.js.map